// extracted by mini-css-extract-plugin
export var contentBody = "_9v-9";
export var headerImage = "_9v-2";
export var imageButton = "_9v-7";
export var imageButtonIcon = "_9v-8";
export var imageHeader = "_9v-4";
export var imageHeaderText = "_9v-5";
export var imageOverlay = "_9v-3";
export var imageTitle = "_9v-6";
export var imageWrapper = "_9v-1";
export var taskList = "_9v-a";
export var widget = "_9v-0";